import axios from "axios";

const API_URL = "https://api.komorotel.com/api";

// ─────────────────────────────────────────
// FETCH CALENDAR
// ─────────────────────────────────────────
export const fetchRoomsCalendar = async (hotelId, startDate, endDate) => {
  const res = await axios.get(
    `${API_URL}/calendar/${hotelId}`,
    {
      params: { startDate, endDate },
      withCredentials: true
    }
  );
  return res.data;
};

// ─────────────────────────────────────────
// UPDATE RATE PRICE (par plage de dates)
// Remplace updateTarif + updateRatePlanPrice
// ─────────────────────────────────────────
export const updateRatePrice = async (ratePriceId, price) => {
  await axios.put(
    `${API_URL}/rateprices/${ratePriceId}`,
    { price },
    { withCredentials: true }
  );
};

export const createRatePrice = async (roomId, ratePlanId, price, startDate, endDate) => {
  await axios.post(
    `${API_URL}/rateprices`,
    { 
      roomId, 
      ratePlanId, 
      price,
      startDate: startDate || undefined, // ✅ undefined si null
      endDate: endDate || undefined       // ✅ undefined si null
    },
    { withCredentials: true }
  );
};

// ─────────────────────────────────────────
// UPDATE AVAILABILITY
// Remplace updateInventory + updateStatus
// ─────────────────────────────────────────
export const updateAvailability = async (roomId, startDate, endDate, totalRooms) => {
  await axios.post(
    `${API_URL}/availability/${roomId}/init`,
    { startDate, endDate, totalRooms },
    { withCredentials: true }
  );
};

export const updateStatus = async (roomId, startDate, endDate, status) => {
  await axios.put(
    `${API_URL}/availability/${roomId}/status`,
    { startDate, endDate, status },
    { withCredentials: true }
  );
};

// ─────────────────────────────────────────
// SUPPRIMÉES
// updateTarif → remplacé par updateRatePrice
// updateRatePlanPrice → remplacé par updateRatePrice
// updateInventory → remplacé par updateAvailability
// updateRoomBasePrice → n'existe plus, prix dans RatePrice
// updateRatePlan → remplacé par /api/rateplans/:id
// createRoom → pas dans ce service
// ─────────────────────────────────────────